import { useEffect, useState } from 'react';
import { Banner, Button, TextField, Title } from '@tryhackme/thm-ui-components';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledManageUsersContainer, StyledSearch, StyledTextFieldContainer } from 'src/features/admin/manage-users/manage-users.styles';
import { SEO } from 'src/common/components';
import { SearchMessage } from 'src/features/admin/manage-users/components/search-message/search-message';
import { ApiResponseStatus } from 'src/common/enums';
import { ReactComponent as BannerImage } from 'src/images/svgs/manage-users-banner.svg';
import { useSearchQuery } from './manage-users.slice';
import { User } from './components/user/user';
export const AdminManageUsers = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string | undefined>();
  const {
    data
  } = useSearchQuery({
    data: searchQuery!
  }, {
    skip: !searchQuery,
    refetchOnMountOrArgChange: true
  });
  useEffect(() => {
    if (searchQuery && searchQuery !== searchValue) {
      setSearchValue(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);
  return <section data-sentry-component="AdminManageUsers" data-sentry-source-file="manage-users.tsx">
      <SEO title="Admin Manage Users" description="Manage Users page" data-sentry-element="SEO" data-sentry-source-file="manage-users.tsx" />
      <Banner Image={BannerImage} right="0" data-sentry-element="Banner" data-sentry-source-file="manage-users.tsx">
        <Title titleText="Manage Users" subTitleText="View and delete users" isInBanner data-sentry-element="Title" data-sentry-source-file="manage-users.tsx" />
      </Banner>
      <StyledManageUsersContainer data-sentry-element="StyledManageUsersContainer" data-sentry-source-file="manage-users.tsx">
        <StyledSearch data-sentry-element="StyledSearch" data-sentry-source-file="manage-users.tsx">
          <StyledTextFieldContainer data-sentry-element="StyledTextFieldContainer" data-sentry-source-file="manage-users.tsx">
            <TextField variant="input" placeholder="Enter username, email or user ID" leftAdornment={<FontAwesomeIcon icon={faSearch} />} onChange={e => setSearchValue(e.target.value.trim())} value={searchValue} onKeyDown={e => {
            if (e.key === 'Enter') {
              setSearchQuery(searchValue);
            }
          }} data-sentry-element="TextField" data-sentry-source-file="manage-users.tsx" />
          </StyledTextFieldContainer>
          {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
          <Button variant="solid" color="add" onClick={() => {
          setSearchQuery(searchValue);
        }} data-sentry-element="Button" data-sentry-source-file="manage-users.tsx">
            <FontAwesomeIcon icon={faSearch} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="manage-users.tsx" />
            Search
          </Button>
        </StyledSearch>
        {!data && <SearchMessage title="Search for a user to manage" subtitle="You can search for users by entering their username, email or user ID" />}
        {data && data.status === ApiResponseStatus.SUCCESS && data.data && <User user={data.data} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />}
        {data && data.status !== ApiResponseStatus.SUCCESS && <SearchMessage title="No users found" subtitle="Check for typos or try entering a different username, email or user ID" />}
      </StyledManageUsersContainer>
    </section>;
};